import React from "react";
import Box from "@mui/material/Box";

interface ColorFieldProps {
    value?: string;
    showText?: boolean;
    onChange?: (hex: string) => void;
    style?: React.CSSProperties;
    className?: string;
}

const ColorField = ({ value, showText, onChange, style, className }: ColorFieldProps) => {
    const current = value || "#000000";
    return (
        <Box
            className={className}
            style={style}
            sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}
        >
            <input
                type="color"
                value={current}
                onChange={(e) => onChange?.(e.target.value)}
                style={{
                    width: 32,
                    height: 32,
                    padding: 0,
                    border: "1px solid #d9d9d9",
                    borderRadius: 4,
                    background: "none",
                    cursor: "pointer",
                }}
            />
            {showText && <span>{current.toUpperCase()}</span>}
        </Box>
    );
};

export default ColorField;
